export default function IconSportsHall() {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <polygon points="32 4 5 23.06 8.97 25.17 32 8.91 55.03 25.17 59 23.06 32 4" />
      {/* eslint-disable-next-line max-len */}
      <path d="M35,44.79l-3.85-5.41,0,0v0h0l.06-.49h0l.08-.5.52-3.47L32,33.85l1.17,1.3a3.35,3.35,0,0,0,3.43,1l5.71-1.34-1.55-2.23-5.21,1-3.26-5a1.61,1.61,0,0,0-.21-.3h0a3.8,3.8,0,0,0-3-1.46,3.6,3.6,0,0,0-1.27.2h0l-.2.08-2.23,1.28L22.8,29.72h0l-.54.31a6,6,0,0,0-2.35,2.82l-2.63,4.9,2.78.13,2.74-4.45L25.05,32l.19-.12,0,.27-.87,6.36h0v0l0,0-4.21,6.65-8.57.4,1.56,2.89L22,48.33a1.07,1.07,0,0,0,.85-.4l4.79-5.67L31.91,47l1.61,8.95L36.8,56,35.45,45.83A2.61,2.61,0,0,0,35,44.79Z" />
      <path d="M30,26a3.49,3.49,0,1,0-3.23-3.69A3.46,3.46,0,0,0,30,26Z" />
      <ellipse cx="45.57" cy="47.58" rx="4.71" ry="4.79" />
    </svg>
  );
}
